/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * this component is used to load form IFrames and communicate with them
 */
var $ = require('jquery');
var _ = require('underscore');
var operateCallBack = require('./operate.service').operateCallback;
var addOperationOptions = require('./operations.service');
var submitStyle = require('./submit-button');
var loading = require('./loading.service');
var groupService = require('./group.service');
var domService = require('./dom.service');
var paymentLayout = require('./payment-option-layout.service');
var rootScope = require('./root-scope.service');
var handleSpecialButton = require('./util/special-buttons').handleSpecialButton;
var browserData = require('./browser-data.service');

const { RiskPlugin } = require('../../plugins/riskPlugin');

function getTradeUKFrameHeight(network) {
    // if desktop version return value from api json
    if (!rootScope.isCardView()) {
        return network.iFrameHeight;
    }
    //if card view:

    // if it is a network
    if (!network.maskedAccount) {
        return 206;
    }

    // if is update only
    if (rootScope.isUpdate()) {
        return 80;
    }

    //if registered account and payment request
    return 80;
}

function getProvidedFrameHeight(network) {
    // As a first step to move knowledge and logic to front end
    // for trade UK the form is different in selective native so the height will be different as well
    if (network.networkCode === 'TRADE-UK') {
        return getTradeUKFrameHeight(network);
    }
    // if desktop version return value from api json
    if (!rootScope.isCardView()) {
        return network.iFrameHeight;
    }

    //if card view:

    // if it is a network
    if (!network.maskedAccount) {
        if (rootScope.isPayout()) {
            return 206;
        }

        return 270;
    }

    // payout and registered account
    if (rootScope.isPayout()) {
        return 0;
    }

    // if is update only
    if (rootScope.isUpdate()) {
        return 156;
    }

    //if registered account and payment request
    return 80;
}

function getFrameHeight(network) {
    return rootScope.getIFrameScale() * getProvidedFrameHeight(network);
}

/**
 * Handles the load of the form when it is an iframe.
 *
 * @param network Network what is selected (an instance of applicable or registered network)
 */
function loadIframeForm(network) {
    var formId = network.networkCode;
    var formContainer = $(domService.getFormContainerId(formId, rootScope.getAllNetworks()));
    if (!formContainer.attr('initialized') || !formContainer.find('iframe')) {
        var formUrl = network.links.iFrame;
        var replacedHTML =
            '<iframe frameborder="0" src="' +
            modifyIframeSrc(network) +
            '" height="' +
            getFrameHeight(network) +
            '" data-loaded="' +
            formId +
            '" width="100%"></iframe>';

        rootScope.setOpgOrigin(createOriginIframeUrl(formUrl));
        if (!rootScope.getMessageListener()) {
            rootScope.setMessageListener(addMessageListener());
        }

        formContainer.append(replacedHTML);

        addOperationOptions(network, formContainer);
    }

    formContainer.attr('initialized', true);

    if (rootScope.getSelectedNetworkCode() === formId) {
        formContainer.show(rootScope.getAnimationSpeed(), function () {
            submitStyle.disableButtonUneditable(formContainer, formId);
        });
    }
    handleSpecialButton(formContainer, network);
}

function addQueryParameter(uri, key, value) {
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';

    return uri + separator + key + '=' + value;
}

function addWidgetCssUrl(uri, widgetCssUrl) {
    return addQueryParameter(uri, 'widgetCssUrl', widgetCssUrl);
}

function addCssUrl(uri, cssUrl) {
    return addQueryParameter(uri, 'cssUrl', cssUrl);
}

function replaceNetworkQueryString(uri, networksList) {
    var re = new RegExp('([?&])' + 'network' + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    var networksCode = _.pluck(networksList, 'code').join();
    if (uri.match(re)) {
        return uri.replace(re, '$1networks=' + networksCode + '$2');
    } else {
        return uri + separator + 'networks=' + networksCode;
    }
}

/**
 * it returns the absolute url
 * if url is absolute just returns it
 * if url is relative then use toAbsoluteUrl(relativeUrl)
 * @param {String} url relative or absolute url
 * @returns {String} absolute url
 */
function getAbsoluteUrl(url) {
    if (url && url.length) {
        if (['.', '/'].includes(url[0])) return toAbsoluteUrl(url);
        return url;
    }
    return '';
}

/**
 * converts relative url to absolute url
 * @param {String} relative relative url
 */
function toAbsoluteUrl(relative) {
    var base = window.location.origin + window.location.pathname;
    var stack = base.split('/');
    var parts = relative.split('/');
    // removes current file name (or empty string)
    // (omit if "base" is the current folder without trailing slash)
    stack.pop();
    for (var i = 0; i < parts.length; i++) {
        if (parts[i] === '.') continue;
        else if (parts[i] === '..') stack.pop();
        else stack.push(parts[i]);
    }
    return stack.join('/');
}

function modifyIframeSrc(network) {
    var formUrl = network.links.iFrame;
    var cssUrl = rootScope.getCssUrl();
    var transformedCssUrl = getAbsoluteUrl(cssUrl);
    var widgetCssUrl = rootScope.getWidgetCssUrl();
    var transformedWidgetCssUrl = getAbsoluteUrl(widgetCssUrl);
    if (cssUrl) {
        formUrl = addCssUrl(formUrl, transformedCssUrl);
    }
    if (widgetCssUrl) {
        formUrl = addWidgetCssUrl(formUrl, transformedWidgetCssUrl);
    }
    var allNetworks = rootScope.getAllNetworks();
    var groupCode = groupService.getGroup(network.networkCode, allNetworks);
    var networksGrouped = groupCode ? allNetworks[groupCode] : null;

    if (networksGrouped && networksGrouped.length > 1) {
        return replaceNetworkQueryString(formUrl, networksGrouped);
    } else {
        return formUrl;
    }
}

function addMessageListener() {
    window.addEventListener('message', function (event) {
        if (event.origin === rootScope.getOpgOrigin()) {
            if (event.data['type'] === 'operation_response_event') {
                var response = event.data['response'];
                operateCallBack(null, response);
            } else if (event.data['type'] === 'validation_response_event') {
                if (event.data['action_id'] === 'PAY') {
                    loading.submitButtonNormal();
                }
            } else if (event.data['type'] === 'detection_response_event') {
                var code = event.data.response['method'];
                var groupType = groupService.getGroup(code, rootScope.getAllNetworks());
                if (code && code !== 'null') {
                    $('iframe[data-loaded="' + domService.getSmartSwitchCurrentNetwork(groupType, true) + '"]').attr('data-loaded', code);
                }
                paymentLayout.handleSmartSwitchForm(code, true);
            }
        }
    });
    return true;
}

function createOriginIframeUrl(link) {
    return link.substring(0, link.lastIndexOf('/paymentpage/iframe'));
}

/**
 * Sends response event to outer frame.
 *
 * @param {contentWindow} HTMLIFrameElement.contentWindow Iframe to send the message to.
 * @param {Object} message type of the event {type, action_id, request}
 * @param {String} origin Specifies what the origin of targetWindow must be for the event to be dispatched, either as the literal string "*" (indicating no preference) or as a URI.
 */
function sendResponseMessage(iFrame, message, origin) {
    iFrame.postMessage(message, origin);
}

/**
 * Send payment_action message to iframe to validate and operate the form
 */
function operate() {
    var selectedNetwork = rootScope.getSelectedNetwork();
    var networkCode = selectedNetwork.networkCode;
    var iFrame = $(domService.getFormContainerId(networkCode, rootScope.getAllNetworks()) + ' iframe')[0].contentWindow;
    var request = rootScope.getOperations(selectedNetwork) || {};
    request.browserData = browserData;

    const operationType = rootScope.getOperationType();
    if (operationType === 'charge' || operationType === 'preset') request.providerRequests = RiskPlugin.getRiskData();

    var message = {
        type: 'payment_action',
        action_id: 'PAY',
        request: request,
    };
    sendResponseMessage(iFrame, message, rootScope.getOpgOrigin());
}

module.exports = {
    loadIframeForm: loadIframeForm,
    operate: operate,
};
